import script from "./ProsemirrorInputBox.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ProsemirrorInputBox.vue?vue&type=script&lang=ts"
export * from "./ProsemirrorInputBox.vue.ts?vue&type=script&lang=ts!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ProsemirrorInputBox.vue?vue&type=script&lang=ts"

import "./ProsemirrorInputBox.vue.scss?vue&type=style&index=0&id=648469a6&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./ProsemirrorInputBox.vue?vue&type=style&index=0&id=648469a6&lang=scss"

const __exports__ = script;

export default __exports__